<template>
  <div class="input-group" :class="bottomMargin">
    <div class="input-group-prepend">
      <span class="input-group-text">$</span>
    </div>
    <input
      type="number" 
      step=".01" 
      class="form-control" 
      aria-label="$"
      :placeholder="inputPlaceholder"
      ref="amount_input"
      :id="inputId"
      :min="inputMin"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
    />
  </div>
</template>

<script>
  export default {
    emits: ['update:modelValue'],
    props: {
      modelValue: [String, Number],
      inputId: String,
      inputMin: [String, Array],
      inputPlaceholder: String,
      disabled: Boolean,
      bottomMargin: {
        type: String,
        default: 'mb-3'
      }
    }
  }
</script>
